import { render } from "./MustBeStaffedBanner.vue?vue&type=template&id=2833e7ae"
import script from "./MustBeStaffedBanner.vue?vue&type=script&lang=js"
export * from "./MustBeStaffedBanner.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__